<script lang="ts">

    let {
        catalogue,
        onAutocompleteSelection
    }: {
        catalogue: string[],
        onAutocompleteSelection?: (val: string) => void
    } = $props();

    let filterText: string = $state("");
    let showAutocomplete: boolean = $state(false);
    let candidateSelectionIndex: number = $state(0);
    let candidates: string[] = $derived.by((): string[] => {
        return catalogue.filter((v: string): boolean => {
            return v.toLowerCase().indexOf(filterText.toLowerCase()) >= 0;
        });
    })

    let initialized = false;
    $effect(() => {
        const _candidates = candidates;
        const _filterText = filterText;

        // This guard helps by not showing autocomplete on load.
        if (!initialized) {
            initialized = true;
            return;
        }
        if(_candidates.length > 0) {
            showAutocomplete = true;
        }
        if(_filterText.length > 0) {
            showAutocomplete = true;
        }
    })



    function autoCompleteTypingHandler(ev: KeyboardEvent) {
        // Arrow key codes up 38, down 40
        if(ev.keyCode == 40) {
            if(showAutocomplete) {
                candidateSelectionIndex = (candidateSelectionIndex+1) % candidates.length
            }
            if(candidates.length == 0) {
                candidateSelectionIndex = -1;
            }
            showAutocomplete = true;
        } else if(ev.keyCode == 38) {
            if(showAutocomplete) {
                candidateSelectionIndex--;
            }

            if(candidateSelectionIndex < 0) {
                candidateSelectionIndex = (candidates.length-1) % candidates.length;
            }

            if(candidates.length == 0) {
                candidateSelectionIndex = -1;
            }
            showAutocomplete = true;
        }

        if (ev.key === 'Enter' || ev.keyCode === 13) {
            selectionMade();

            showAutocomplete = false;
        } else if(ev.key == "Escape") {
            showAutocomplete = false;
        }
    }

    function selectionMade(val?: string) {
        const selectedText = val ?? (
            (candidateSelectionIndex >= 0 && candidateSelectionIndex < candidates.length)
                ? candidates[candidateSelectionIndex]
                : null
        );
        if (selectedText && onAutocompleteSelection) {
            onAutocompleteSelection(selectedText);
        }
        if(selectedText) {
            filterText = "";
            showAutocomplete = false;
        }
    }

    let rootEl: HTMLElement;
    let dropdownEl: HTMLElement;

    $effect(() => {
        if (dropdownEl && showAutocomplete) {
            const selected = dropdownEl.children[candidateSelectionIndex] as HTMLElement;
            selected?.scrollIntoView({ block: 'nearest' });
        }
    });

    $effect(() => {
        function handleOutsideClick(ev: MouseEvent) {
            if (rootEl && !rootEl.contains(ev.target as Node)) {
                showAutocomplete = false;
            }
        }
        document.addEventListener('click', handleOutsideClick);
        return () => document.removeEventListener('click', handleOutsideClick);
    });

</script>

<div class="input-group position-relative" bind:this={rootEl}>
    <input
        id=""
        type="text"
        class="form-control"
        placeholder="Filter..."
        onkeyup={autoCompleteTypingHandler}
        bind:value={filterText}
    />
    <div bind:this={dropdownEl} class="position-absolute w-100 bg-dark text-light {!showAutocomplete ? "d-none" : ""}" style="top: 100%; z-index: 1000; max-height: 200px; overflow-y: auto;">
        {#each candidates as candidate, index}
            <div aria-roledescription="Select the auto complete: {candidate}" class="row m-0" onmousedown={(e) => { e.preventDefault(); selectionMade(candidate); }}>
                <div class="col-10 p-4 {index == candidateSelectionIndex ? "selected bg-secondary" : ""}">
                    {candidate}
                </div>
            </div>
        {/each}
    </div>        
</div>
